<template>
  <v-row>
    <v-col cols="12">
      <FormUserGroup
        dispatch="userGroupStore/create"
        button_title="create"
        button_icon="mdi-plus"
        :user-group="userGroup"
      ></FormUserGroup>
    </v-col>
  </v-row>
</template>

<script>
import FormUserGroup from "./FormUserGroup.vue";
export default {
  name: "NewUserGroup",
  components: {
    FormUserGroup
  },
  computed: {
    userGroup() {
      let userGroup = undefined;
      if (this.$route.query["userGroup"]) {
        return this.$store.getters["userGroupStore/getItem"];
      }
      return userGroup;
    }
  },
  mounted() {
    this.$route.query["userGroup"] &&
      this.$store.dispatch("userGroupStore/get", {
        id: this.$route.query["userGroup"]
      });
  }
};
</script>

<style scoped></style>
